var languages = {
    AR: 'ar',
    EN: 'en'
};
export default Object.freeze(languages);
